import {Link, useLocation} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {KairosMark} from '@/components/kairos-mark'
import {LandingHero} from '@/components/landing/hero'
import {PreciosResolver} from '@/components/landing/precios'
import {ComoFunciona, EnJuego, ParaQuien, QueIncluye, ServicioSst} from '@/components/landing/secciones'
import {SiteHeaderActions} from '@/components/site-header-actions'
import {useCanonicalLink} from '@/hooks/common/use-canonical-link'

/** Lo que "/" muestra a un visitante sin sesión; ProtectedRoute lleva a los autenticados a su home. */

function LandingHeader() {
  const {t} = useTranslation()
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-5 sm:px-6">
        <div className="flex items-center gap-2 text-foreground">
          <KairosMark />
          <span className="font-heading text-lg tracking-tight">Kairos</span>
        </div>
        <div className="flex items-center gap-3 sm:gap-5">
          <Link
            to="/manual"
            className="hidden text-sm text-muted-foreground hover:text-foreground sm:inline"
            data-testid="landing-nav-manual">
            {t('landing.nav.manual')}
          </Link>
          <SiteHeaderActions tone="light" />
        </div>
      </div>
    </header>
  )
}

function LandingFooter() {
  const {t} = useTranslation()
  return (
    <footer className="bg-ink-deep text-ink-deep-foreground">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-10 text-sm text-ink-deep-foreground/70 sm:flex-row sm:justify-between">
        <div className="flex items-center gap-2 text-ink-deep-foreground">
          <KairosMark />
          <span className="font-heading text-sm tracking-tight">Kairos</span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-4">
          <Link to="/manual" className="hover:text-ink-deep-foreground" data-testid="landing-footer-manual">
            {t('landing.nav.manual')}
          </Link>
          <Link to="/login" className="hover:text-ink-deep-foreground" data-testid="landing-footer-login">
            {t('landing.nav.login')}
          </Link>
          <Link to="/registro/empresa" className="hover:text-ink-deep-foreground" data-testid="landing-footer-registro">
            {t('landing.nav.cta')}
          </Link>
          {/* Sin texto legal aprobado: enlaces reservados, nunca inventar copy legal. */}
          <span className="cursor-not-allowed opacity-50" title={t('landing.footer.legalTodo')}>
            {t('landing.footer.terminos')}
          </span>
          <span className="cursor-not-allowed opacity-50" title={t('landing.footer.legalTodo')}>
            {t('landing.footer.privacidad')}
          </span>
        </nav>
      </div>
    </footer>
  )
}

export function LandingPage() {
  // /inicio: camino de vuelta para quien tiene sesión; "/" sigue siendo la única URL indexable.
  const {pathname} = useLocation()
  useCanonicalLink(pathname === '/' ? null : `${window.location.origin}/`)
  return (
    <div className="min-h-screen bg-background" data-testid="landing-page">
      <LandingHeader />
      <LandingHero />
      <EnJuego />
      <ComoFunciona />
      <QueIncluye />
      <ParaQuien />
      <ServicioSst />
      <PreciosResolver />
      <LandingFooter />
    </div>
  )
}
